import React from 'react';


const Steps = () => {
  return (
    <div className='max-w-[1540px] bg-blue-900 mx-auto py-16 px-4 '>
      <div className=" items-center">
      <h1 className='text-[#FFFFFF] font-bold  text-4xl flex justify-center'>Streamline Document Certification in 3 Simple Steps</h1></div>
      <p className="text-[#FFFFFF] text-2xl mt-4 flex justify-center">Empowering blockchain tokenization: swift, economical, and fortified.</p>
    
      <div className="grid gap-2 my-6">
        <div className="bg-[#F0F4F8] text-black p-6 shadow-md">
          <h2 className="text-xl font-bold mb-2">01</h2>
          <h3 className="text-lg font-bold mb-2">Create Account</h3>
          <p>Sign up to get your unique user profile and start using Trustforge.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <div className="bg-white text-black p-6  shadow-md">
            <h2 className="text-xl font-bold mb-2">02</h2>
            <h3 className="text-lg font-bold mb-2">Upload Document</h3>
            <p>Choose and upload your document to receive a unique QR code and hash.</p>
          </div>
          <div className="bg-white text-black p-6 shadow-md">
            <h2 className="text-xl font-bold mb-2">03</h2>
            <h3 className="text-lg font-bold mb-2">Verify & Share</h3>
            <p>Verify your document's authenticity and share it with confidence.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;